require('/opt/odin/app/frontend/components/menu/index.module.scss');
require('/opt/odin/app/frontend/components/menu/submenu/contest.erb');
require('/opt/odin/app/frontend/components/menu/submenu/lessons.erb');
require('/opt/odin/app/frontend/components/menu/submenu/courses.erb');module.exports = "../../app/cells/components/menu/show.erb";